export function FormatNumber(value: number, isCurrency?: boolean) {
	let modifiedValue;
	let returnValue = "";
	if (isCurrency) {
		modifiedValue = value.toFixed(2);
		returnValue = "£";
	} else modifiedValue = value.toString();
	return `${returnValue}${modifiedValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
}